export const ALL_RECENT_ITEMS_COUNT_HOME_REFRESH = 6;
